// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__s_U3_"};